import React from 'react';
import cx from 'classnames';

import { titleCaseFirstLetter, wordpressImgToImgixURL } from 'Utilities';
import { LANDING_PAGE_EVENTS, LANDING_PAGE_SECTIONS_NAMES } from 'Utilities/analytics';

import { Content } from 'LegacySBCRA/Content/Content';

import { usePageRefEvents } from '../../../common/Hooks/usePageRefEvents';

import styles from './BodyArea.scss';

type BodyAreaProps = {
  contentBody: string;
  imgAlt?: string;
  imgSrc: string;
  position?: 'left' | 'right';
  theme?: 'light' | 'dark';
  title?: string;
};

const BodyArea = ({
  contentBody, imgAlt = '', imgSrc, position, theme, title = '',
}: BodyAreaProps) => {
  const onRefTrigger = (label?: string) =>
    LANDING_PAGE_EVENTS.SECTION_LOAD({ label, name: LANDING_PAGE_SECTIONS_NAMES.SEO });
  const { setRef } = usePageRefEvents({ eventLabels: [title], onRefTrigger });

  const displayContentBody = () => {
    if (!contentBody || contentBody.length === 0) {
      return (null);
    }

    contentBody = contentBody.replace(/<(span|div).+?>/g, '').replace(/<\/(span|div)>/g, '').trim(); // Strip out WP rubbish

    return (
      <div
        dangerouslySetInnerHTML={{ __html: contentBody }}
        className={styles.contentContainer}
      />
    );
  };

  return (
    <Content
      className={styles.innerContainer}
      wrapper={{
        className: cx(styles.bodyArea, styles[`bodyArea${titleCaseFirstLetter(theme)}`]),
      }}
    >
      <div ref={(ref) => setRef(ref)} className={styles.innerContainer}>
        <div className={styles.textContent}>
          <h3 className={styles.title}>{title}</h3>
          {displayContentBody()}
        </div>
        <div className={cx(styles.illustrationContainer, styles[`illustrationContainer${titleCaseFirstLetter(position)}`])}>
          {(imgSrc) ? (
            <img
              alt={imgAlt}
              className={styles.illustration}
              height="640"
              loading="lazy"
              src={`${wordpressImgToImgixURL(imgSrc)}&w=${480 * 2}`}
              width="960"
            />
          ) : (null)}
        </div>
      </div>
    </Content>
  );
};

export default BodyArea;
